var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bulb",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.519,
    height: 26.519,
    viewBox: "0 0 26.519 26.519",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_230",
    "data-name": "Path 230",
    d: "M4.972,26.519a.566.566,0,0,1-.211-.042.552.552,0,0,1-.341-.51V20.994H2.762A2.766,2.766,0,0,1,0,18.232V2.762A2.766,2.766,0,0,1,2.762,0H23.757a2.766,2.766,0,0,1,2.762,2.762V18.232a2.766,2.766,0,0,1-2.762,2.762H10.726L5.362,26.358A.552.552,0,0,1,4.972,26.519ZM2.762,1.1A1.659,1.659,0,0,0,1.1,2.762V18.232a1.659,1.659,0,0,0,1.657,1.657h2.21a.553.553,0,0,1,.552.552v4.191l4.581-4.581a.553.553,0,0,1,.391-.162H23.757a1.659,1.659,0,0,0,1.657-1.657V2.762A1.659,1.659,0,0,0,23.757,1.1Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_231",
    "data-name": "Path 231",
    d: "M13.577,16.259h-2.21a1.158,1.158,0,0,1-1.1-1.3V13.5a1.955,1.955,0,0,0-.747-1.585A4.943,4.943,0,0,1,7.5,7.844,5,5,0,0,1,12.4,3a5.1,5.1,0,0,1,3.576,1.434,4.9,4.9,0,0,1,1.47,3.508,4.953,4.953,0,0,1-2,3.957,1.99,1.99,0,0,0-.767,1.606v1.65A1.106,1.106,0,0,1,13.577,16.259ZM12.471,4.1h-.056A3.932,3.932,0,0,0,8.606,7.866a3.834,3.834,0,0,0,1.565,3.157,3.063,3.063,0,0,1,1.2,2.474v1.459a.4.4,0,0,0,.04.219l2.17-.02V13.5a3.1,3.1,0,0,1,1.212-2.493A3.815,3.815,0,0,0,15.2,5.221,3.851,3.851,0,0,0,12.471,4.1Z",
    transform: "translate(0.787 0.315)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_232",
    "data-name": "Path 232",
    d: "M13.867,13.1H10.552a.552.552,0,0,1,0-1.1h3.315a.552.552,0,0,1,0,1.1Z",
    transform: "translate(1.05 1.259)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulb);
export default __webpack_public_path__ + "static/media/bulb.fe11299da2833d813cee8299c84dd803.svg";
export { ForwardRef as ReactComponent };